export default "__VITE_PUBLIC_ASSET__0177bf0c__"